(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-hoodie-preview"]) return;
  try {
    
  if (!customElements.get('heritage-hoodie-preview')) {
    customElements.define('heritage-hoodie-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        document.title = this.dataset.pageTitle;
        const dialog = this.querySelector('dialog');
        const bagButton = this.querySelector('[data-preview-bag]');
        const selectionStatus = this.querySelector('[data-selection-status]');
        const hero = this.querySelector('.heritage-hoodie-preview__hero-image');
        const pages = ['bag', 'confirmation', 'status', 'emails'];
        const stages = ['confirmed', 'production', 'qc', 'shipped', 'delivered'];
        const emailSelector = this.querySelector('[data-email-select]');
        const showPage = (page, moveFocus = true) => {
          if (!pages.includes(page)) return;
          this.querySelectorAll('[data-journey-panel]').forEach((panel) => { panel.hidden = panel.dataset.journeyPanel !== page; });
          this.querySelectorAll('.heritage-hoodie-preview__journey-nav [data-journey]').forEach((button) => {
            if (button.dataset.journey === page) button.setAttribute('aria-current', 'step');
            else button.removeAttribute('aria-current');
          });
          if (moveFocus) this.querySelector(`[data-journey-panel="${page}"] h3`).focus({ preventScroll: true });
          dialog.scrollTo({ top: 0, behavior: 'instant' });
        };
        const showStage = (stage) => {
          const selectedIndex = stages.indexOf(stage);
          if (selectedIndex < 0) return;
          this.querySelectorAll('[data-stage-panel]').forEach((panel) => { panel.hidden = panel.dataset.stagePanel !== stage; });
          this.querySelectorAll('[data-stage]').forEach((button) => { button.setAttribute('aria-pressed', String(button.dataset.stage === stage)); });
          this.querySelectorAll('[data-stage-item]').forEach((item) => { item.dataset.complete = String(stages.indexOf(item.dataset.stageItem) < selectedIndex); });
        };
        const showEmail = (email) => {
          if (!Array.from(emailSelector.options).some((option) => option.value === email)) return;
          emailSelector.value = email;
          this.querySelectorAll('[data-email-panel]').forEach((panel) => { panel.hidden = panel.dataset.emailPanel !== email; });
        };
        const choices = () => ({
          colour: this.querySelector('[data-choice="colour"]:checked'),
          size: this.querySelector('[data-choice="size"]:checked')
        });
        const setImage = (thumbnail) => {
          if (!thumbnail || !hero || thumbnail.closest('[data-colour-gallery]').hidden) return;
          hero.srcset = thumbnail.dataset.imageSrcset;
          hero.src = thumbnail.dataset.imageSrc;
          hero.alt = thumbnail.dataset.imageAlt;
          this.querySelectorAll('[data-image-id]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumbnail)));
          const strip = thumbnail.parentElement;
          strip.scrollTo({ left: thumbnail.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumbnail.clientWidth) / 2, behavior: 'instant' });
        };
        const showColourGallery = (colourInput) => {
          if (!colourInput) return;
          const galleries = Array.from(this.querySelectorAll('[data-colour-gallery]'));
          galleries.forEach((gallery) => { gallery.hidden = gallery.dataset.colourGallery !== colourInput.value; });
          const gallery = galleries.find((item) => !item.hidden);
          const thumbnails = gallery ? Array.from(gallery.querySelectorAll('[data-image-id]')) : [];
          const firstImage = thumbnails[0];
          this.querySelectorAll('[data-image-id]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
          hero.hidden = !firstImage;
          this.querySelector('[data-gallery-empty]').hidden = Boolean(firstImage);
          this.querySelector('[data-gallery-status]').textContent = firstImage ? gallery.dataset.galleryCaption : '';
          setImage(firstImage);
          if (gallery) gallery.scrollLeft = 0;
        };
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-acknowledge]')) this.querySelector('[data-demo-confirm]').disabled = !event.target.checked;
          if (event.target.matches('[data-email-select]')) showEmail(event.target.value);
          if (!event.target.matches('[data-choice]')) return;
          const selection = choices();
          const complete = Boolean(selection.colour && selection.size);
          bagButton.disabled = !complete;
          selectionStatus.textContent = complete ? this.dataset.readyMessage : this.dataset.selectionMessage;
          if (event.target.dataset.choice === 'colour') {
            this.querySelector('[data-current-colour]').textContent = event.target.dataset.displayValue;
            showColourGallery(event.target);
          }
        });
        this.addEventListener('click', (event) => {
          const pageButton = event.target.closest('[data-journey]');
          if (pageButton) showPage(pageButton.dataset.journey);
          const stageButton = event.target.closest('[data-stage]');
          if (stageButton) showStage(stageButton.dataset.stage);
          const stageEmailButton = event.target.closest('[data-stage-email]');
          if (stageEmailButton) {
            showEmail(stageEmailButton.dataset.stageEmail === 'confirmed' ? 'confirmation' : stageEmailButton.dataset.stageEmail);
            showPage('emails');
          }
          if (event.target.closest('[data-demo-confirm]') && this.querySelector('[data-acknowledge]').checked) showPage('confirmation');
          const thumbnail = event.target.closest('[data-image-id]');
          if (thumbnail) setImage(thumbnail);
          if (event.target.closest('[data-open-size-guide]')) {
            const guide = this.querySelector('[data-size-guide]');
            guide.open = true;
            guide.querySelector('summary').focus({ preventScroll: true });
            guide.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
          if (event.target.closest('[data-close-dialog]')) dialog.close();
          if (event.target === dialog) dialog.close();
        });
        bagButton.addEventListener('click', () => {
          const selection = choices();
          if (!selection.colour || !selection.size) return;
          Object.entries(selection).forEach(([key, input]) => {
            this.querySelectorAll(`[data-summary="${key}"]`).forEach((element) => { element.textContent = input.dataset.displayValue || input.value; });
          });
          this.querySelector('[data-acknowledge]').checked = false;
          this.querySelector('[data-demo-confirm]').disabled = true;
          showPage('bag', false);
          showStage('confirmed');
          showEmail('confirmation');
          dialog.showModal();
        });
        dialog.addEventListener('close', () => bagButton.focus());
        showColourGallery(choices().colour);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-hoodie"]) return;
  try {
    
  if (!customElements.get('heritage-product')) {
    customElements.define('heritage-product', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        const form = this.querySelector('form');
        const variantSelect = this.querySelector('[data-variant-select]');
        const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        const controls = this.querySelector('[data-enhanced-options]');
        const button = this.querySelector('[data-add-to-cart]');
        const status = this.querySelector('[data-selection-status]');
        const hero = this.querySelector('.heritage-product__hero-image');
        const radios = Array.from(this.querySelectorAll('[data-option-index]'));
        const groups = Array.from(controls.querySelectorAll('[data-option-group]'));
        const selectedOptions = () => groups.map((group) => group.querySelector('input:checked')?.value || '');
        const setImage = (thumbnail) => {
          if (!thumbnail || !hero || thumbnail.closest('[data-colour-gallery]').hidden) return;
          hero.srcset = thumbnail.dataset.imageSrcset;
          hero.src = thumbnail.dataset.imageSrc;
          hero.alt = thumbnail.dataset.imageAlt;
          this.querySelectorAll('[data-image-id]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumbnail)));
        };
        const showColour = () => {
          const colour = selectedOptions()[0];
          const radio = radios.find((input) => input.dataset.optionIndex === '0' && input.checked);
          this.querySelector('[data-current-colour]').textContent = radio?.dataset.displayValue || colour;
          const galleries = Array.from(this.querySelectorAll('[data-colour-gallery]'));
          galleries.forEach((gallery) => { gallery.hidden = gallery.dataset.colourGallery !== colour; });
          const gallery = galleries.find((item) => !item.hidden);
          const firstImage = gallery?.querySelector('[data-image-id]');
          hero.hidden = !firstImage;
          this.querySelector('[data-gallery-empty]').hidden = Boolean(firstImage);
          this.querySelector('[data-gallery-status]').textContent = firstImage ? gallery.dataset.galleryCaption : '';
          setImage(firstImage);
          if (gallery) gallery.scrollLeft = 0;
        };
        const update = (updateUrl = false) => {
          const options = selectedOptions();
          const complete = options.length > 0 && options.every(Boolean);
          const variant = complete ? variants.find((item) => item.options.every((value, index) => value === options[index]) && item.options.length === options.length) : null;
          variantSelect.value = variant ? String(variant.id) : '';
          this.querySelectorAll('[data-option-property]').forEach((input) => {
            input.disabled = !variant;
            input.value = variant ? variant.options[Number(input.dataset.optionProperty)] : '';
          });
          const available = Boolean(variant?.available);
          button.disabled = !available;
          status.textContent = !complete ? this.dataset.selectionMessage : !available ? this.dataset.unavailableMessage : this.dataset.readyMessage;
          if (variant) {
            this.querySelectorAll('[data-price]').forEach((element) => { element.textContent = variant.formattedPrice; });
          }
          if (updateUrl) {
            const url = new URL(window.location.href);
            if (variant) url.searchParams.set('variant', variant.id);
            else url.searchParams.delete('variant');
            history.replaceState(history.state, '', url);
          }
          return variant;
        };
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-option-index]')) {
            if (event.target.dataset.optionIndex === '0') showColour();
            update(true);
          }
        });
        this.addEventListener('click', (event) => {
          const thumbnail = event.target.closest('[data-image-id]');
          if (thumbnail) setImage(thumbnail);
          if (event.target.closest('[data-open-size-guide]')) {
            const guide = this.querySelector('[data-size-guide]');
            guide.open = true;
            guide.querySelector('summary').focus({ preventScroll: true });
            guide.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
        });
        form.addEventListener('submit', (event) => {
          const variant = update();
          if (!variant?.available) {
            event.preventDefault();
          }
        });
        this.dataset.initialized = 'true';
        controls.hidden = false;
        this.querySelector('[data-native-options]').hidden = true;
        variantSelect.required = false;
        radios.forEach((input) => { input.required = true; });
        showColour();
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-pants-preview"]) return;
  try {
    
  if (!customElements.get('heritage-pants-preview')) {
    customElements.define('heritage-pants-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        document.title = this.dataset.pageTitle;
        const dialog = this.querySelector('dialog');
        const bagButton = this.querySelector('[data-preview-bag]');
        const selectionStatus = this.querySelector('[data-selection-status]');
        const hero = this.querySelector('.heritage-pants-preview__hero-image');
        const pages = ['bag', 'confirmation', 'status', 'emails'];
        const stages = ['confirmed', 'production', 'qc', 'shipped', 'delivered'];
        const emailSelector = this.querySelector('[data-email-select]');
        const showPage = (page, moveFocus = true) => {
          if (!pages.includes(page)) return;
          this.querySelectorAll('[data-journey-panel]').forEach((panel) => { panel.hidden = panel.dataset.journeyPanel !== page; });
          this.querySelectorAll('.heritage-pants-preview__journey-nav [data-journey]').forEach((button) => {
            if (button.dataset.journey === page) button.setAttribute('aria-current', 'step');
            else button.removeAttribute('aria-current');
          });
          if (moveFocus) this.querySelector(`[data-journey-panel="${page}"] h3`).focus({ preventScroll: true });
          dialog.scrollTo({ top: 0, behavior: 'instant' });
        };
        const showStage = (stage) => {
          const selectedIndex = stages.indexOf(stage);
          if (selectedIndex < 0) return;
          this.querySelectorAll('[data-stage-panel]').forEach((panel) => { panel.hidden = panel.dataset.stagePanel !== stage; });
          this.querySelectorAll('[data-stage]').forEach((button) => { button.setAttribute('aria-pressed', String(button.dataset.stage === stage)); });
          this.querySelectorAll('[data-stage-item]').forEach((item) => { item.dataset.complete = String(stages.indexOf(item.dataset.stageItem) < selectedIndex); });
        };
        const showEmail = (email) => {
          if (!Array.from(emailSelector.options).some((option) => option.value === email)) return;
          emailSelector.value = email;
          this.querySelectorAll('[data-email-panel]').forEach((panel) => { panel.hidden = panel.dataset.emailPanel !== email; });
        };
        const choices = () => ({
          colour: this.querySelector('[data-choice="colour"]:checked'),
          size: this.querySelector('[data-choice="size"]:checked')
        });
        const setImage = (thumbnail) => {
          if (!thumbnail || !hero || thumbnail.closest('[data-colour-gallery]').hidden) return;
          hero.srcset = thumbnail.dataset.imageSrcset;
          hero.src = thumbnail.dataset.imageSrc;
          hero.alt = thumbnail.dataset.imageAlt;
          this.querySelectorAll('[data-image-id]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumbnail)));
          const strip = thumbnail.parentElement;
          strip.scrollTo({ left: thumbnail.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumbnail.clientWidth) / 2, behavior: 'instant' });
        };
        const showColourGallery = (colourInput) => {
          if (!colourInput) return;
          const galleries = Array.from(this.querySelectorAll('[data-colour-gallery]'));
          galleries.forEach((gallery) => { gallery.hidden = gallery.dataset.colourGallery !== colourInput.value; });
          const gallery = galleries.find((item) => !item.hidden);
          const thumbnails = gallery ? Array.from(gallery.querySelectorAll('[data-image-id]')) : [];
          const firstImage = thumbnails[0];
          this.querySelectorAll('[data-image-id]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
          hero.hidden = !firstImage;
          this.querySelector('[data-gallery-empty]').hidden = Boolean(firstImage);
          this.querySelector('[data-gallery-status]').textContent = firstImage ? gallery.dataset.galleryCaption : '';
          setImage(firstImage);
          if (gallery) gallery.scrollLeft = 0;
        };
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-acknowledge]')) this.querySelector('[data-demo-confirm]').disabled = !event.target.checked;
          if (event.target.matches('[data-email-select]')) showEmail(event.target.value);
          if (!event.target.matches('[data-choice]')) return;
          const selection = choices();
          const complete = Boolean(selection.colour && selection.size);
          bagButton.disabled = !complete;
          selectionStatus.textContent = complete ? this.dataset.readyMessage : this.dataset.selectionMessage;
          if (event.target.dataset.choice === 'colour') {
            this.querySelector('[data-current-colour]').textContent = event.target.dataset.displayValue;
            showColourGallery(event.target);
          }
        });
        this.addEventListener('click', (event) => {
          const pageButton = event.target.closest('[data-journey]');
          if (pageButton) showPage(pageButton.dataset.journey);
          const stageButton = event.target.closest('[data-stage]');
          if (stageButton) showStage(stageButton.dataset.stage);
          const stageEmailButton = event.target.closest('[data-stage-email]');
          if (stageEmailButton) {
            showEmail(stageEmailButton.dataset.stageEmail === 'confirmed' ? 'confirmation' : stageEmailButton.dataset.stageEmail);
            showPage('emails');
          }
          if (event.target.closest('[data-demo-confirm]') && this.querySelector('[data-acknowledge]').checked) showPage('confirmation');
          const thumbnail = event.target.closest('[data-image-id]');
          if (thumbnail) setImage(thumbnail);
          if (event.target.closest('[data-open-size-guide]')) {
            const guide = this.querySelector('[data-size-guide]');
            guide.open = true;
            guide.querySelector('summary').focus({ preventScroll: true });
            guide.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
          if (event.target.closest('[data-close-dialog]')) dialog.close();
          if (event.target === dialog) dialog.close();
        });
        bagButton.addEventListener('click', () => {
          const selection = choices();
          if (!selection.colour || !selection.size) return;
          Object.entries(selection).forEach(([key, input]) => {
            this.querySelectorAll(`[data-summary="${key}"]`).forEach((element) => { element.textContent = input.dataset.displayValue || input.value; });
          });
          this.querySelector('[data-acknowledge]').checked = false;
          this.querySelector('[data-demo-confirm]').disabled = true;
          showPage('bag', false);
          showStage('confirmed');
          showEmail('confirmation');
          dialog.showModal();
        });
        dialog.addEventListener('close', () => bagButton.focus());
        showColourGallery(choices().colour);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-pants"]) return;
  try {
    
  if (!customElements.get('heritage-product')) {
    customElements.define('heritage-product', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        const form = this.querySelector('form');
        const variantSelect = this.querySelector('[data-variant-select]');
        const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        const controls = this.querySelector('[data-enhanced-options]');
        const button = this.querySelector('[data-add-to-cart]');
        const status = this.querySelector('[data-selection-status]');
        const hero = this.querySelector('.heritage-product__hero-image');
        const radios = Array.from(this.querySelectorAll('[data-option-index]'));
        const groups = Array.from(controls.querySelectorAll('[data-option-group]'));
        const selectedOptions = () => groups.map((group) => group.querySelector('input:checked')?.value || '');
        const setImage = (thumbnail) => {
          if (!thumbnail || !hero || thumbnail.closest('[data-colour-gallery]').hidden) return;
          hero.srcset = thumbnail.dataset.imageSrcset;
          hero.src = thumbnail.dataset.imageSrc;
          hero.alt = thumbnail.dataset.imageAlt;
          this.querySelectorAll('[data-image-id]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumbnail)));
        };
        const showColour = () => {
          const colour = selectedOptions()[0];
          const radio = radios.find((input) => input.dataset.optionIndex === '0' && input.checked);
          this.querySelector('[data-current-colour]').textContent = radio?.dataset.displayValue || colour;
          const galleries = Array.from(this.querySelectorAll('[data-colour-gallery]'));
          galleries.forEach((gallery) => { gallery.hidden = gallery.dataset.colourGallery !== colour; });
          const gallery = galleries.find((item) => !item.hidden);
          const firstImage = gallery?.querySelector('[data-image-id]');
          hero.hidden = !firstImage;
          this.querySelector('[data-gallery-empty]').hidden = Boolean(firstImage);
          this.querySelector('[data-gallery-status]').textContent = firstImage ? gallery.dataset.galleryCaption : '';
          setImage(firstImage);
          if (gallery) gallery.scrollLeft = 0;
        };
        const update = (updateUrl = false) => {
          const options = selectedOptions();
          const complete = options.length > 0 && options.every(Boolean);
          const variant = complete ? variants.find((item) => item.options.every((value, index) => value === options[index]) && item.options.length === options.length) : null;
          variantSelect.value = variant ? String(variant.id) : '';
          this.querySelectorAll('[data-option-property]').forEach((input) => {
            input.disabled = !variant;
            input.value = variant ? variant.options[Number(input.dataset.optionProperty)] : '';
          });
          const available = Boolean(variant?.available);
          button.disabled = !available;
          status.textContent = !complete ? this.dataset.selectionMessage : !available ? this.dataset.unavailableMessage : this.dataset.readyMessage;
          if (variant) {
            this.querySelectorAll('[data-price]').forEach((element) => { element.textContent = variant.formattedPrice; });
          }
          if (updateUrl) {
            const url = new URL(window.location.href);
            if (variant) url.searchParams.set('variant', variant.id);
            else url.searchParams.delete('variant');
            history.replaceState(history.state, '', url);
          }
          return variant;
        };
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-option-index]')) {
            if (event.target.dataset.optionIndex === '0') showColour();
            update(true);
          }
        });
        this.addEventListener('click', (event) => {
          const thumbnail = event.target.closest('[data-image-id]');
          if (thumbnail) setImage(thumbnail);
          if (event.target.closest('[data-open-size-guide]')) {
            const guide = this.querySelector('[data-size-guide]');
            guide.open = true;
            guide.querySelector('summary').focus({ preventScroll: true });
            guide.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
        });
        form.addEventListener('submit', (event) => {
          const variant = update();
          if (!variant?.available) {
            event.preventDefault();
          }
        });
        this.dataset.initialized = 'true';
        controls.hidden = false;
        this.querySelector('[data-native-options]').hidden = true;
        variantSelect.required = false;
        radios.forEach((input) => { input.required = true; });
        showColour();
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-preview"]) return;
  try {
    
  if (!customElements.get('heritage-preview')) {
    customElements.define('heritage-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const dialog = this.querySelector('dialog');
        const bagButton = this.querySelector('[data-preview-bag]');
        const selectionStatus = this.querySelector('[data-selection-status]');
        const hero = this.querySelector('.heritage-preview__hero-image');
        const pages = ['bag', 'confirmation', 'status', 'emails'];
        const stages = ['confirmed', 'production', 'qc', 'shipped', 'delivered'];
        const emailSelector = this.querySelector('[data-email-select]');
        const showPage = (page, moveFocus = true) => {
          if (!pages.includes(page)) return;
          this.querySelectorAll('[data-journey-panel]').forEach((panel) => { panel.hidden = panel.dataset.journeyPanel !== page; });
          this.querySelectorAll('.heritage-preview__journey-nav [data-journey]').forEach((button) => {
            if (button.dataset.journey === page) button.setAttribute('aria-current', 'step');
            else button.removeAttribute('aria-current');
          });
          if (moveFocus) this.querySelector(`[data-journey-panel="${page}"] h3`).focus({ preventScroll: true });
          dialog.scrollTo({ top: 0, behavior: 'instant' });
        };
        const showStage = (stage) => {
          const selectedIndex = stages.indexOf(stage);
          if (selectedIndex < 0) return;
          this.querySelectorAll('[data-stage-panel]').forEach((panel) => { panel.hidden = panel.dataset.stagePanel !== stage; });
          this.querySelectorAll('[data-stage]').forEach((button) => { button.setAttribute('aria-pressed', String(button.dataset.stage === stage)); });
          this.querySelectorAll('[data-stage-item]').forEach((item) => { item.dataset.complete = String(stages.indexOf(item.dataset.stageItem) < selectedIndex); });
        };
        const showEmail = (email) => {
          if (!Array.from(emailSelector.options).some((option) => option.value === email)) return;
          emailSelector.value = email;
          this.querySelectorAll('[data-email-panel]').forEach((panel) => { panel.hidden = panel.dataset.emailPanel !== email; });
        };
        const choices = () => ({
          colour: this.querySelector('[data-choice="colour"]:checked'),
          hoodie: this.querySelector('[data-choice="hoodie"]:checked'),
          pants: this.querySelector('[data-choice="pants"]:checked')
        });
        const setImage = (thumbnail) => {
          if (!thumbnail || !hero || thumbnail.closest('[data-colour-gallery]').hidden) return;
          hero.srcset = thumbnail.dataset.imageSrcset;
          hero.src = thumbnail.dataset.imageSrc;
          hero.alt = thumbnail.dataset.imageAlt;
          this.querySelectorAll('[data-image-id]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumbnail)));
          const strip = thumbnail.parentElement;
          strip.scrollTo({ left: thumbnail.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumbnail.clientWidth) / 2, behavior: 'instant' });
        };
        const showColourGallery = (colourInput) => {
          if (!colourInput) return;
          const galleries = Array.from(this.querySelectorAll('[data-colour-gallery]'));
          galleries.forEach((gallery) => { gallery.hidden = gallery.dataset.colourGallery !== colourInput.value; });
          const gallery = galleries.find((item) => !item.hidden);
          const thumbnails = gallery ? Array.from(gallery.querySelectorAll('[data-image-id]')) : [];
          const firstImage = thumbnails.find((item) => item.dataset.imageId === colourInput.dataset.colourImageId) || thumbnails[0];
          this.querySelectorAll('[data-image-id]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
          hero.hidden = !firstImage;
          this.querySelector('[data-gallery-empty]').hidden = Boolean(firstImage);
          this.querySelector('[data-gallery-status]').textContent = firstImage ? gallery.dataset.galleryCaption : '';
          setImage(firstImage);
          if (gallery) gallery.scrollLeft = 0;
        };
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-acknowledge]')) this.querySelector('[data-demo-confirm]').disabled = !event.target.checked;
          if (event.target.matches('[data-email-select]')) showEmail(event.target.value);
          if (!event.target.matches('[data-choice]')) return;
          const selection = choices();
          const complete = Boolean(selection.colour && selection.hoodie && selection.pants);
          bagButton.disabled = !complete;
          selectionStatus.textContent = complete ? this.dataset.readyMessage : this.dataset.selectionMessage;
          if (event.target.dataset.choice === 'colour') {
            this.querySelector('[data-current-colour]').textContent = event.target.dataset.displayValue;
            showColourGallery(event.target);
          }
        });
        this.addEventListener('click', (event) => {
          const pageButton = event.target.closest('[data-journey]');
          if (pageButton) showPage(pageButton.dataset.journey);
          const stageButton = event.target.closest('[data-stage]');
          if (stageButton) showStage(stageButton.dataset.stage);
          const stageEmailButton = event.target.closest('[data-stage-email]');
          if (stageEmailButton) {
            showEmail(stageEmailButton.dataset.stageEmail === 'confirmed' ? 'confirmation' : stageEmailButton.dataset.stageEmail);
            showPage('emails');
          }
          if (event.target.closest('[data-demo-confirm]') && this.querySelector('[data-acknowledge]').checked) showPage('confirmation');
          const thumbnail = event.target.closest('[data-image-id]');
          if (thumbnail) setImage(thumbnail);
          if (event.target.closest('[data-open-size-guide]')) {
            const guide = this.querySelector('[data-size-guide]');
            guide.open = true;
            guide.querySelector('summary').focus({ preventScroll: true });
            guide.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
          if (event.target.closest('[data-close-dialog]')) dialog.close();
          if (event.target === dialog) dialog.close();
        });
        bagButton.addEventListener('click', () => {
          const selection = choices();
          if (!selection.colour || !selection.hoodie || !selection.pants) return;
          Object.entries(selection).forEach(([key, input]) => {
            this.querySelectorAll(`[data-summary="${key}"]`).forEach((element) => { element.textContent = input.dataset.displayValue || input.value; });
          });
          this.querySelector('[data-acknowledge]').checked = false;
          this.querySelector('[data-demo-confirm]').disabled = true;
          showPage('bag', false);
          showStage('confirmed');
          showEmail('confirmation');
          dialog.showModal();
        });
        dialog.addEventListener('close', () => bagButton.focus());
        showColourGallery(choices().colour);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-set"]) return;
  try {
    
  if (!customElements.get('heritage-product')) {
    customElements.define('heritage-product', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        const form = this.querySelector('form');
        const variantSelect = this.querySelector('[data-variant-select]');
        const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        const controls = this.querySelector('[data-enhanced-options]');
        const button = this.querySelector('[data-add-to-cart]');
        const status = this.querySelector('[data-selection-status]');
        const hero = this.querySelector('.heritage-product__hero-image');
        const radios = Array.from(this.querySelectorAll('[data-option-index]'));
        const groups = Array.from(controls.querySelectorAll('[data-option-group]'));
        const selectedOptions = () => groups.map((group) => group.querySelector('input:checked')?.value || '');
        const setImage = (thumbnail) => {
          if (!thumbnail || !hero || thumbnail.closest('[data-colour-gallery]').hidden) return;
          hero.srcset = thumbnail.dataset.imageSrcset;
          hero.src = thumbnail.dataset.imageSrc;
          hero.alt = thumbnail.dataset.imageAlt;
          this.querySelectorAll('[data-image-id]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumbnail)));
        };
        const showColour = () => {
          const colour = selectedOptions()[0];
          const radio = radios.find((input) => input.dataset.optionIndex === '0' && input.checked);
          this.querySelector('[data-current-colour]').textContent = radio?.dataset.displayValue || colour;
          const galleries = Array.from(this.querySelectorAll('[data-colour-gallery]'));
          galleries.forEach((gallery) => { gallery.hidden = gallery.dataset.colourGallery !== colour; });
          const gallery = galleries.find((item) => !item.hidden);
          const firstImage = gallery?.querySelector('[data-image-id]');
          hero.hidden = !firstImage;
          this.querySelector('[data-gallery-empty]').hidden = Boolean(firstImage);
          this.querySelector('[data-gallery-status]').textContent = firstImage ? gallery.dataset.galleryCaption : '';
          setImage(firstImage);
          if (gallery) gallery.scrollLeft = 0;
        };
        const update = (updateUrl = false) => {
          const options = selectedOptions();
          const complete = options.length > 0 && options.every(Boolean);
          const variant = complete ? variants.find((item) => item.options.every((value, index) => value === options[index]) && item.options.length === options.length) : null;
          variantSelect.value = variant ? String(variant.id) : '';
          this.querySelectorAll('[data-option-property]').forEach((input) => {
            input.disabled = !variant;
            input.value = variant ? variant.options[Number(input.dataset.optionProperty)] : '';
          });
          const available = Boolean(variant?.available);
          const launchLocked = this.dataset.launchLocked === 'true';
          button.disabled = launchLocked || !available;
          status.textContent = launchLocked ? this.dataset.launchMessage : !complete ? this.dataset.selectionMessage : !available ? this.dataset.unavailableMessage : this.dataset.readyMessage;
          if (variant) {
            this.querySelectorAll('[data-price]').forEach((element) => { element.textContent = variant.formattedPrice; });
          }
          if (updateUrl) {
            const url = new URL(window.location.href);
            if (variant) url.searchParams.set('variant', variant.id);
            else url.searchParams.delete('variant');
            history.replaceState(history.state, '', url);
          }
          return variant;
        };
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-option-index]')) {
            if (event.target.dataset.optionIndex === '0') showColour();
            update(true);
          }
        });
        this.addEventListener('click', (event) => {
          const thumbnail = event.target.closest('[data-image-id]');
          if (thumbnail) setImage(thumbnail);
          if (event.target.closest('[data-open-size-guide]')) {
            const guide = this.querySelector('[data-size-guide]');
            guide.open = true;
            guide.querySelector('summary').focus({ preventScroll: true });
            guide.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
        });
        form.addEventListener('submit', (event) => {
          const variant = update();
          if (this.dataset.launchLocked === 'true' || !variant?.available) {
            event.preventDefault();
          }
        });
        this.dataset.initialized = 'true';
        controls.hidden = false;
        this.querySelector('[data-native-options]').hidden = true;
        variantSelect.required = false;
        radios.forEach((input) => { input.required = true; });
        showColour();
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
